import {twMerge} from "tailwind-merge";
import {getCodeMode} from "@/utils/global-functions";

export default function CodeInput({label, id, requiredLabel = false, classes = {} ,...otherProps}) {

    const {inputClasses = "", labelClasses = ""} = classes;

    return (
        <div className="w-full">
            <label className={twMerge("block mr-[1.125rem] mb-2.5 text-sm", labelClasses)} htmlFor={id}>
                {label}
                {requiredLabel ? <span className="text-pol-red align-super mr-0.5">*</span> : <span className="align-super" />}
            </label>
            <div className="relative w-full" style={{direction: "ltr"}}>
                <div
                    className="absolute left-px top-px flex-center bg-transparent rounded-3xl w-full h-full tracking-[0.3rem] pointer-events-none">{getCodeMode(otherProps.value)}</div>
                <input
                    id={id}
                    // autoComplete="one-time-code"
                    inputMode="numeric"
                    className={twMerge("pol-simple-input bg-pol-light-7 border-pol-gray-light-3 caret-transparent tracking-[0.3rem] !text-white/0 placeholder:text-white/0", inputClasses)}
                    {...otherProps}
                />
            </div>
        </div>
    )
}
